module.exports = __webpack_public_path__ + "img/6.b86f5b3d.png";